import { GppMaybe } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const AccessPage = () => {
	const { t } = useTranslation();
	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-gray-100">
			<div className="mx-auto w-1/3 max-w-lg rounded-lg bg-white p-8 text-center shadow-lg">
				<GppMaybe className="mx-auto h-24 w-24 text-red-600" />
				<h1 className="text-5xl font-bold text-red-600">403</h1>
				<h2 className="mt-4 text-xl font-semibold text-gray-700">{t('not_access')}</h2>
				<p className="mt-2 text-lg text-gray-500">{t('you_dont_have_permission_to_access_this_page')}</p>
				<div className="mt-6">
					<Link to="/" className="font-medium text-blue-500 hover:text-blue-700">
						{t('comeback')}
					</Link>
				</div>
			</div>
		</div>
	);
};

export default AccessPage;
